"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectNovoDark = exports.selectNovo = exports.select = void 0;
const polished_1 = require("polished");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const zIndex_const_1 = __importDefault(require("../choices/zIndex.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const select = {
    avatarPaddingRight: spacing_const_1.default.xs,
    backgroundColor: color_const_1.default.white,
    backgroundColorDisabled: color_const_1.default.cloudyBlue100,
    backgroundColorHover: color_const_1.default.white,
    baseUnit: 0,
    borderColor: color_const_1.default.cloudyBlue300,
    borderColorDisabled: color_const_1.default.cloudyBlue300,
    borderColorError: color_const_1.default.coral,
    borderColorFocus: color_const_1.default.dodgerBlue,
    borderColorHover: color_const_1.default.cloudyBlue300,
    borderRadius: 0,
    borderWidth: '1px',
    checkboxPaddingRight: spacing_const_1.default.xs,
    clearIconColor: color_const_1.default.cloudyBlue,
    clearIconFocusedColor: color_const_1.default.steel700,
    clearIconFocusedHoverColor: color_const_1.default.pickledBluewood,
    clearIconHoverColor: color_const_1.default.steel700,
    controlFocusBoxShadow: 'none',
    dropdownIndicatorColor: color_const_1.default.steel700,
    dropdownIndicatorColorDisabled: color_const_1.default.steel700,
    fontFamily: font_const_1.default.family,
    fontSize: font_const_1.default.sizeSm,
    headingBorderColor: color_const_1.default.cloudyBlue300,
    headingBorderSize: size_const_1.default.borderSizeDefault,
    headingBorderStyle: 'solid',
    headingMargin: 0,
    headingPadding: spacing_const_1.default.xs,
    headingTextColor: color_const_1.default.pickledBluewood,
    headingTextFontSize: font_const_1.default.sizeSm,
    headingTextFontWeight: font_const_1.default.weightAttention,
    iconHeight: size_const_1.default.medium,
    iconMargin: 0,
    iconPaddingRight: spacing_const_1.default.xs,
    iconSize: 24,
    indicatorsContainerPaddingHorizontal: spacing_const_1.default.xs,
    inputBoxSizeDefault: size_const_1.default.formItemSizeLarge,
    inputBoxSizeLarge: '48px',
    inputBoxSizeSmall: size_const_1.default.formItemSizeSmall,
    inputColor: color_const_1.default.pickledBluewood,
    labelFontWeight: font_const_1.default.weightAttention,
    lineHeight: font_const_1.default.lineHeightSm,
    marginTop: spacing_const_1.default.xxs,
    menuBackgroundColor: color_const_1.default.white,
    menuBorderColor: color_const_1.default.cloudyBlue300,
    menuBorderSize: size_const_1.default.borderSizeDefault,
    menuBorderStyle: 'solid',
    menuBoxShadowColor: `${(0, polished_1.rgba)(color_const_1.default.pickledBluewood800, 0.1)}`,
    menuBoxShadowSize: size_const_1.default.shadowDefault,
    menuGutter: 1,
    menuZindex: zIndex_const_1.default.z1000,
    multiValueChipPaddingVerticalDefault: '6px',
    multiValueChipPaddingVerticalLarge: '8px',
    multiValueChipPaddingVerticalSmall: spacing_const_1.default.xxxs,
    noOptionTextColor: color_const_1.default.cloudyBlue,
    noOptionTextFontSize: font_const_1.default.sizeSm,
    optionActiveBackgroundColor: color_const_1.default.cloudyBlue300,
    optionHoveredBackgroundColor: color_const_1.default.cloudyBlue100,
    optionIconColor: color_const_1.default.pickledBluewood,
    optionPaddingHorizontal: spacing_const_1.default.xs,
    optionPaddingVertical: spacing_const_1.default.xxs,
    optionSelectedBackground: 'color',
    optionTextColor: color_const_1.default.pickledBluewood,
    optionTextFontSize: font_const_1.default.sizeSm,
    optionTextFontWeightSelected: font_const_1.default.weightAttention,
    optionTextSelectedColor: color_const_1.default.dodgerBlue,
    placeholderIconColor: color_const_1.default.cloudyBlue,
    placeholderTextColor: color_const_1.default.cloudyBlue,
    placeholderTextColorDisabled: color_const_1.default.cloudyBlue,
    selectedOptionTextColor: color_const_1.default.steel700,
    selectedOptionTextColorDisabled: color_const_1.default.cloudyBlue,
    shortMultiDisplayPadding: spacing_const_1.default.xxs,
    valueContainerPadding: `0 ${spacing_const_1.default.xs}`,
};
exports.select = select;
const selectNovo = {
    ...select,
    backgroundColor: novo.ui05,
    backgroundColorDisabled: novo.ui05,
    backgroundColorHover: novo.hover08,
    borderColor: novo.ui05,
    borderColorDisabled: novo.ui05,
    borderColorError: novo.action03,
    borderColorFocus: novo.focus01,
    borderColorHover: novo.hover08,
    borderRadius: '6px',
    borderWidth: '2px',
    clearIconColor: novo.icon01,
    clearIconFocusedColor: novo.icon01,
    dropdownIndicatorColor: novo.icon01,
    dropdownIndicatorColorDisabled: novo.disabled02,
    fontFamily: novo.bulletList01.fontFamily,
    fontSize: novo.bulletList01.fontSize,
    headingBorderSize: '0',
    headingMargin: '0',
    headingPadding: `${novo.spacing03} ${novo.spacing05}`,
    headingTextColor: novo.textColor01,
    headingTextFontSize: novo.bodyBold01.fontSize,
    headingTextFontWeight: novo.bodyBold01.fontWeight,
    iconHeight: '28px',
    iconMargin: '0 6px 0 -6px',
    iconPaddingRight: '0',
    iconSet: 'novo',
    iconSize: 20,
    inputBoxSizeDefault: '40px',
    inputBoxSizeLarge: '48px',
    inputBoxSizeSmall: '32px',
    inputColor: novo.textColor01,
    labelFontWeight: novo.bulletList01.fontWeight,
    lineHeight: novo.bulletList01.lineHeight,
    menuBackgroundColor: novo.ui06,
    menuBorderColor: novo.focus01,
    menuBorderSize: '2px',
    menuBoxShadowColor: null,
    menuBoxShadowSize: 0,
    multiValueChipPaddingVerticalDefault: '2px',
    multiValueChipPaddingVerticalLarge: '4px',
    multiValueChipPaddingVerticalSmall: '0px',
    noOptionTextColor: novo.textColor01,
    noOptionTextFontSize: novo.bulletList01.fontSize,
    optionActiveBackgroundColor: '',
    optionHoveredBackgroundColor: novo.ui02,
    optionIconColor: novo.textColor01,
    optionPaddingHorizontal: novo.spacing05,
    optionPaddingVertical: novo.spacing03,
    optionSelectedBackground: 'icon',
    optionTextColor: novo.textColor01,
    optionTextFontSize: novo.bulletList01.fontSize,
    optionTextFontWeightSelected: novo.bulletList01.fontWeight,
    optionTextSelectedColor: novo.textColor01,
    placeholderIconColor: novo.textColor01,
    placeholderTextColor: novo.textColor02,
    placeholderTextColorDisabled: novo.disabled02,
    selectedOptionTextColor: novo.textColor01,
    selectedOptionTextColorDisabled: novo.disabled02,
    valueContainerPadding: `0 0 0 ${novo.spacing05}`,
};
exports.selectNovo = selectNovo;
const selectNovoDark = {
    ...selectNovo,
    backgroundColor: novoDark.ui05,
    backgroundColorDisabled: novoDark.ui05,
    backgroundColorHover: novoDark.hover08,
    borderColor: novoDark.ui05,
    borderColorDisabled: novoDark.ui05,
    borderColorError: novoDark.action03,
    borderColorFocus: novoDark.focus01,
    borderColorHover: novoDark.hover08,
    clearIconColor: novoDark.icon01,
    clearIconFocusedColor: novoDark.icon01,
    dropdownIndicatorColor: novoDark.icon01,
    dropdownIndicatorColorDisabled: novoDark.disabled02,
    headingTextColor: novoDark.textColor01,
    inputColor: novoDark.textColor01,
    menuBackgroundColor: novoDark.ui06,
    menuBorderColor: novoDark.focus01,
    noOptionTextColor: novoDark.textColor01,
    optionHoveredBackgroundColor: novoDark.ui02,
    optionIconColor: novoDark.textColor01,
    optionTextColor: novoDark.textColor01,
    optionTextSelectedColor: novoDark.textColor01,
    placeholderIconColor: novoDark.textColor01,
    placeholderTextColor: novoDark.textColor02,
    placeholderTextColorDisabled: novoDark.disabled02,
    selectedOptionTextColor: novoDark.textColor01,
    selectedOptionTextColorDisabled: novoDark.disabled02,
};
exports.selectNovoDark = selectNovoDark;
